module.exports = __webpack_public_path__ + "static/media/noun_chart.389c4105.svg";